export const BUILD_VERSION = '1788114712';
